<template functional>
  <div class="overview">
    <div class="overview__info-wrapper">
      <div class="overview__info">
        <h6 class="overview__header content-type">learning path</h6>
        <h4 class="overview__title content-title">{{ props.title }}</h4>
        <p
          v-html="props.description"
          class="overview__description content-description"
        ></p>
      </div>
      <div class="overview__progress-wrapper" v-if="props.isAuthenticated">
        <p class="overview__progress lead">
          progress:
          <span class="overview__percent-complete data">
            <span v-if="props.progress">{{ props.progress }}</span>
            <span v-else>0</span>
            % Complete
          </span>
        </p>
        <components
          :is="injections.components.ProgressBar"
          :value="props.progress.toString()"
          class="overview__progress-bar"
        ></components>
        <div class="overview__resume-btn-wrapper">
          <button
            @click="listeners['resumePath']"
            class="overview__resume-btn btn__large"
          >
            <span
              v-if="props.progress && props.progress !== 0"
              class="overview__resume-keyword"
              >Resume
            </span>
            <span v-else class="overview__resume-keyword">Begin </span> Path
            <span
              class="overview__resume-icon btn__large-icon btn__large-icon--alt material-icons"
              >play_circle_filled</span
            >
          </button>
        </div>
      </div>
    </div>
    <div class="overview__media-wrapper">
      <div
        v-if="props.sampleVideoId && props.sampleVideoId !== ''"
        class="overview__video-wrapper"
      >
        <iframe
          :src="`https://player.vimeo.com/video/${props.sampleVideoId}`"
          width="560"
          height="349"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
      <div class="overview__details">
        <div class="overview__details-top">
          <p class="overview__duration">
            <span class="lead">Duration:</span>
            <span class="data">{{ props.duration }}</span>
          </p>
          <p class="overview__difficulty">
            <span class="lead">Difficulty:</span>
            <component
              :is="injections.components.DifficultyComponent"
              :difficulty="props.difficulty"
              class="overview__difficulty-component data"
            ></component>
          </p>
        </div>
        <p v-if="props.activities" class="overview__activities">
          <span class="lead">Activites:</span>
          <span class="data"
            >{{ props.totalCourses }} Courses,
            {{ props.activities.videos }} Videos</span
          >
        </p>
      </div>
      <p class="overview__instructor-header lead">Instructors:</p>
      <div class="overview__instructors-wrapper">
        <div class="overview__head-instructor">
          <div
            class="overview__instructor"
            @click="
              listeners['searchPresenter'](props.instructors[0].full_name)
            "
          >
            <img
              class="overview__head-instructor-img"
              :src="props.instructors[0].image"
            />
            <p class="overview__head-instructor-name data">
              {{ props.instructors[0].full_name }}
            </p>
            <p class="overview__head-instructor-primary lead">Primary</p>
          </div>
        </div>
        <div class="overview__instructors">
          <div class="overview__sub-instructors">
            <div
              @click="listeners['searchPresenter'](instructor.full_name)"
              v-for="instructor in props.instructors.slice(1, 100)"
              :key="instructor.full_name"
              class="overview__instructor"
              v-tooltip="{
                content: instructor.full_name,
                placement: 'bottom-center',
              }"
            >
              <img class="overview__instructor-img" :src="instructor.image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DifficultyComponent from '../layout/DifficultyComponent.vue'
import ProgressBar from '@/components/layout/ProgressBar.vue'

export default {
  name: 'LearningPathOverview',
  inject: {
    components: {
      default() {
        return {
          DifficultyComponent,
          ProgressBar,
        }
      },
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    totalCourses: {
      type: Number,
      required: true,
    },
    instructors: {
      type: Array,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: true,
    },
    progress: {
      type: Number,
      required: false,
    },
    floatedProgress: {
      type: Number,
      required: false,
    },
    duration: {
      type: String,
      required: false,
    },
    difficulty: {
      type: Number,
      required: false,
    },
    activities: {
      type: Object,
      required: false,
    },
    pathResume: {
      type: Object,
      required: false,
    },
    sampleVideoId: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  flex-wrap: wrap;
  padding: 75px 25px;
  @include tablet {
    padding: 50px 100px;
    flex-wrap: nowrap;
  }
  &__info-wrapper {
    width: 100%;
    padding-right: 0;
    @include mobile {
      padding-right: 50px;
    }
    @include desktop {
      width: 60%;
      padding-right: 100px;
    }
  }
  &__info {
    margin-bottom: 75px;
  }
  &__progress {
    margin: 0 0 5px 0;
  }
  &__resume-btn-wrapper {
    margin: 35px 0 0 0;
  }
  &__resume-keyword {
    margin-right: 5px;
  }
  &__media-wrapper {
    width: 100%;
    padding-top: 25px;
    @include tablet {
      width: auto;
      padding-top: 50px;
      flex-grow: 1;
    }
  }
  &__video-wrapper {
    position: relative;
    padding-bottom: 52.1%; /* 16:9 */
    padding-top: 25px;
    height: 0;
    margin-top: 1%;
    width: 100%;
    margin: 0 auto;
    display: none;
    @include tablet {
      display: block;
    }
  }
  &__video-wrapper iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  &__details-top {
    display: flex;
  }
  &__difficulty {
    display: flex;
    padding-left: 25px;
    margin-left: 25px;
    border-left: 1px solid var(--gray);
  }
  &__instructors-wrapper {
    display: flex;
    align-items: center;
  }
  &__instructors {
    display: flex;
    flex-wrap: wrap;
  }
  &__instructor {
    cursor: pointer;
    margin-right: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:hover {
      opacity: 0.5;
    }
  }
  &__head-instructor {
    margin-right: 5px;
  }
  &__head-instructor-img {
    border-radius: 100%;
    border: 1px solid var(--orange);
    width: 100px;
  }
  &__head-instructor-name {
    margin-top: 5px;
  }
  &__head-instructor-primary {
    font-size: 0.8rem;
  }
  &__instructor-img {
    border-radius: 100%;
    width: 75px;
  }
  &__sub-instructors {
    display: flex;
    flex-wrap: wrap;
  }
  .btn__large {
    padding-right: 45px;
  }
}
</style>
